$(document).ready(function() {
    var mainowl    = $(".main");
    var testowl    = $(".test");
    var productowl = $(".product-slider");
    mainowl.owlCarousel({
 
        navigation : true, // Show next and prev buttons
        slideSpeed : 300,
        paginationSpeed : 400,
        singleItem: true,
        autoPlay: true,
        navigationText: [
            "<img src='//cdn.shopify.com/s/files/1/0153/5977/t/4/assets/x.left_arrow.png?3699'>",
            "<img src='//cdn.shopify.com/s/files/1/0153/5977/t/4/assets/x.right_arrow.png?3699'>",
        ],

        // "singleItem:true" is a shortcut for:
        // items : 1, 
        // itemsDesktop : false,
        // itemsDesktopSmall : false,
        // itemsTablet: false,
        // itemsMobile : false
    });
    flex = $("#p-flex");
        flex.owlCarousel({

            singleItem: true,
            autoPlay: false,
            autoHeight: true,
            stopOnHover: true,

            afterMove: function() {
                var control;
                control = $('#p-flex .owl-item');
                control.each(function() {
                $.removeData($(".p-selected img"), 'elevateZoom');
                $('.zoomContainer').remove();
                $(this).removeClass('p-selected');
            });
            $(control[flex.data('owlCarousel').currentItem]).addClass('p-selected');
      
            $(".p-selected img").elevateZoom({
            zoomType : "inner",
            cursor: "crosshair",
            responsive: true
            });
        }
    });
  $('[data-flex]').click(function() {
    return flex.trigger('owl.goTo', $(this).data('flex'));
  });
  
    $(".p-selected").elevateZoom({
        zoomType : "inner",
        cursor: "crosshair",
        responsive: true
    });
});

$(document).ready(function() {
 	$("img").unveil();

	$(function() {
		$( "#accordion" ).accordion({
		      heightStyle: "content"
		});
	});
    
});